import Title from "antd/lib/typography/Title";
import { toTitleCase } from "../../../utils/commonfunction";

export default function PoItemSummaryTemp(props) {
  const thCss = {
    border: "1px solid black",
    padding: "6px 12px",
    display: "table-cell",
    color: "black",
  };
  const thCssHead = {
    border: "1px solid black",
    padding: "6px 12px",
    display: "table-cell",
    background: "#4561b9",
    color: "white",
    fontWeight: "bold",
  };
  const headRow = {
    display: "table-row",
    fontWeight: "900",
    color: "#ffffff",
  };

  const list = props?.list || [];
  const headList =
    props.headList || (list.length > 0 ? Object.keys(list[0]) : []);

  const totalRow = headList.map((col, colIndex) => {
    const values = list.map((row) => row[col]);
    const isNumeric = values.every(
      (v) =>
        v === null ||
        v === undefined ||
        v === "" ||
        !isNaN(parseFloat(v))
    );
    const hasNumericValues = values.some(
      (v) =>
        v !== null &&
        v !== undefined &&
        v !== "" &&
        !isNaN(parseFloat(v))
    );
    if (colIndex === 0) return "Total";
    if (isNumeric && hasNumericValues) {
      const sum = list.reduce(
        (acc, row) => acc + (parseFloat(row[col]) || 0),
        0
      );
      return Number.isInteger(sum) ? sum : parseFloat(sum.toFixed(2));
    }
    return "";
  });

  return (
    <div style={{ border: "1px solid gray", padding: 20, width: "100%" }}>
      <table
        style={{ borderCollapse: "collapse", width: "100%" }}
        id="table-to-xls"
      >
        <tr>
          <td colSpan={headList?.length || 6}>
            <Title level={4} style={{ textAlign: "center" }}>
              {props.dateWise
                ? "PO Item Summary (Date Wise)"
                : "PO Item Summary"}
              : {props.branch} - {props.department}
            </Title>
          </td>
        </tr>
        <tr>
          <td colSpan={headList?.length || 6}>
            <Title level={5} style={{ textAlign: "center" }}>
              {props.date}
            </Title>
          </td>
        </tr>
        {headList?.length > 0 && (
          <tr style={headRow}>
            {headList.map((x) => (
              <td key={x} style={thCssHead}>
                {toTitleCase(x || "")}
              </td>
            ))}
          </tr>
        )}
        <tbody>
          {list.map((row, index) => (
            <tr key={index} style={{ pageBreakInside: "avoid" }}>
              {headList.map((col) => (
                <td key={col} style={thCss}>
                  {row[col]}
                </td>
              ))}
            </tr>
          ))}
          {list.length > 0 && (
            <tr style={{ ...headRow, background: "#e8e8e8", fontWeight: "bold" }}>
              {totalRow.map((val, idx) => (
                <td key={idx} style={thCss}>
                  {val}
                </td>
              ))}
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
